// extracted by mini-css-extract-plugin
export default {"root":"_1qni587pXtB4m1viXvthJu"};